<template>
  <div id="page-content" tabindex="-1">
    <span
      aria-label="View Reservation Page"
      aria-live="polite"
      role="contentinfo"
    ></span>
    <h2
      class="public-h5 font-weight-bold mt-5 mb-5"
      :class="isRTLLanguage ? 'rtl' : 'normal'"
    >
      {{ siteText.ui.viewReservationPageHeader }}
    </h2>
    <div v-for="booking in bookings" :key="booking.BookingId">
      <v-card>
        <v-card-text
          class="centerContainer"
          :class="isRTLLanguage ? 'rtl' : 'normal'"
        >
          <reservation-details
            :booking="booking"
            :show-barcode="true"
            :show-map-link="true"
            :show-service-type-link="true"
            :footer-text="siteText.ui.viewMessageText"
            :show-print-link="true"
            :isRTL="isRTLLanguage"
          >
          </reservation-details>
          <div class="text-left">
            <v-layout row wrap>
              <v-flex md4>
                <v-btn
                  class="ma-2 dmv-btn"
                  height="45px"
                  width="290px"
                  @click="cancelReservation(booking)"
                >
                  {{ siteText.ui.viewCancelReservation }}
                </v-btn>
              </v-flex>
              <v-flex md4>
                <v-btn
                  class="ma-2 dmv-btn"
                  height="45px"
                  width="290px"
                  @click="rescheduleReservation(booking)"
                >
                  {{ siteText.ui.viewRescheduleReservation }}
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
      <p></p>
    </div>
    <v-card v-if="displayReservationNotFound">
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText }}
        <strong> {{ confirmationNumber }} </strong>
      </v-card-text>
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText2 }}
      </v-card-text>
    </v-card>
    <div class="text-left pt-4">
      <v-layout row wrap>
        <v-flex md3>
          <v-btn
            v-if="!directNavigation"
       class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.viewBack }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReservationDetails from "../components/ReservationDetails.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ViewReservationPage",
  components: {
    ReservationDetails,
  },
  data() {
    return {
      displayReservationNotFound: false,
    };
  },
  methods: {
    ...mapActions({
      previousPageAction: "previousPage",
    }),
    ...mapActions(["selectBooking"]),
    ...mapActions(["getExistingBookings"]),
    nextPage(page) {
      this.$emit("navigateTo", page);
    },
    back() {
      this.$emit("navigateTo", "DataCollectionPage", {
        header: this.siteText.ui.viewReservationHeader,
        subHeader: this.siteText.ui.viewReservationSubHeader,
        subHeader2: this.siteText.ui.viewReservationSubHeader2,
        pageName: "View Your Reservation",
      });
    },
    cancelReservation(booking) {
      this.previousPageAction({ value: "ViewReservationPage" });
      this.selectBooking(booking);
      this.$emit("navigateTo", "CancelReservationPage", {
        pageName: "Cancel Reservation",
      });
    },
    rescheduleReservation(booking) {
      this.selectBooking(booking);
      this.$emit("navigateTo", "RescheduleReservationPage", {
        pageName: "Current Reservation",
      });
    },
  },
  computed: {
    ...mapGetters(["siteText"]),
    ...mapGetters(["bookings"]),
    ...mapGetters(["directNavigation", "confirmationNumber", "isRTLLanguage"]),
  },
  async mounted() {
    console.log(this.bookings);
    if (this.directNavigation) {
      this.displayReservationNotFound = !(await this.getExistingBookings({
        confirmationNumber: this.confirmationNumber,
      }));
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
